export default "__VITE_ASSET__56cdd493__"